import {
  TButtonTranslations,
} from './npm-controller-menu.ts';

const buttonTranslations: TButtonTranslations = {
  LOAD_JOB: {
    label: 'Załaduj zadanie',
    confirmMessage: '',
    confirmLabel: '',
  },
  START_JOB: {
    label: 'Rozpocznij pracę',
    confirmMessage: 'Potwierdź początek {recipeCode} na {assetDisplayName}.',
    confirmLabel: 'Rozpocznij {recipeCode}',
  },
  ABORT_JOB: {
    label: 'Przerwij zadanie',
    confirmMessage: 'Czy na pewno chcesz przerwać zadanie {jobNo} ({recipeCode}) na {assetDisplayName}?',
    confirmLabel: 'Przerwij {jobNo}',
  },
  RESUME_JOB: {
    label: 'Wznów pracę',
    confirmMessage: 'Czy na pewno chcesz wznowić {recipeCode} na {assetDisplayName}?',
    confirmLabel: 'Wznów {recipeCode}',
  },
};

export default {
  button: buttonTranslations,
};
